/* Differ* — theme.js
   Vanilla JS only. No jQuery, no build step required. */
(function () {
  'use strict';

  /* Mobile menu toggle — unhide first, then animate open a frame later so
     the transition actually runs; on close, wait for the fade before hiding */
  var toggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (toggle && mobileMenu) {
    var menuCloseTimer = null;
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      if (expanded) {
        mobileMenu.classList.remove('is-open');
        menuCloseTimer = setTimeout(function () { mobileMenu.hidden = true; }, 420);
      } else {
        clearTimeout(menuCloseTimer);
        mobileMenu.hidden = false;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { mobileMenu.classList.add('is-open'); });
        });
      }
    });
  }

  /* Accordions (FAQ, product info) — unhide first, open a frame later so the
     unfold transition runs; on close, wait for the fold before hiding */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    var panel = trigger.parentElement.querySelector('[data-accordion-panel]');
    var panelTimer = null;
    trigger.addEventListener('click', function () {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      if (!panel) return;
      if (expanded) {
        panel.classList.remove('is-open');
        panelTimer = setTimeout(function () { panel.hidden = true; }, 560);
      } else {
        clearTimeout(panelTimer);
        panel.hidden = false;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { panel.classList.add('is-open'); });
        });
      }
    });
  });

  /* Cart drawer — slides in after unhide (double rAF so the transition
     runs); Escape closes; focus is handed to the drawer and returned */
  var cartToggle = document.querySelector('[data-cart-drawer-toggle]');
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  if (cartToggle && cartDrawer) {
    var closers = cartDrawer.querySelectorAll('[data-cart-drawer-close]');
    var drawerTimer = null;
    var openDrawer = function () {
      clearTimeout(drawerTimer);
      cartDrawer.hidden = false;
      cartDrawer.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { cartDrawer.classList.add('is-open'); });
      });
      var closeBtn = cartDrawer.querySelector('.cart-drawer__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    };
    var closeDrawer = function () {
      if (cartDrawer.hidden) return;
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      drawerTimer = setTimeout(function () { cartDrawer.hidden = true; }, 520);
      cartToggle.focus({ preventScroll: true });
    };
    cartToggle.addEventListener('click', openDrawer);
    closers.forEach(function (el) { el.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  /* Scroll-reveal */
  var animated = document.querySelectorAll('[data-animate]');
  if ('IntersectionObserver' in window && animated.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    animated.forEach(function (el) { observer.observe(el); });

    /* Failsafe — content must never be left invisible.
       Every [data-animate] element starts at opacity 0, so anything that stops
       the observer delivering (a stray inline style, a broken frame loop, a
       browser quirk) would blank the page. Shortly after load: reveal whatever
       is already on screen, and if nothing at all has been revealed, assume the
       observer is dead and show everything. */
    window.addEventListener('load', function () {
      setTimeout(function () {
        var anyRevealed = document.querySelector('[data-animate].is-visible');
        animated.forEach(function (el) {
          if (el.classList.contains('is-visible')) return;
          if (!anyRevealed) { el.classList.add('is-visible'); return; }
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
        });
      }, 500);
    });
  } else {
    animated.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Countdown */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) return;
    var daysEl = el.querySelector('[data-countdown-days]');
    var hoursEl = el.querySelector('[data-countdown-hours]');
    var minsEl = el.querySelector('[data-countdown-minutes]');
    var secsEl = el.querySelector('[data-countdown-seconds]');

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) { diff = 0; }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (daysEl) daysEl.textContent = String(d).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
      if (minsEl) minsEl.textContent = String(m).padStart(2, '0');
      if (secsEl) secsEl.textContent = String(s).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });

  /* Custom cursor dot (opt-in via theme setting) */
  if (document.documentElement.getAttribute('data-cursor') === 'custom-dot') {
    var dot = document.createElement('div');
    dot.className = 'cursor-dot';
    document.body.appendChild(dot);
    window.addEventListener('mousemove', function (e) {
      dot.style.left = e.clientX + 'px';
      dot.style.top = e.clientY + 'px';
    });
  }

  /* Email capture — validate every differ waitlist form (hero + CTA) */
  var bindEmailForm = function (form, input, error) {
    if (!form || !input || !error) return;
    form.addEventListener('submit', function (e) {
      var v = input.value.trim();
      var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRe.test(v)) {
        e.preventDefault();
        error.hidden = false;
      }
    });
    input.addEventListener('input', function () { error.hidden = true; });
  };

  var heroForm = document.querySelector('#DifferHeroForm');
  if (heroForm) {
    bindEmailForm(
      heroForm,
      heroForm.querySelector('#DifferHeroEmail'),
      heroForm.parentElement.querySelector('[data-differ-email-error]') || heroForm.querySelector('[data-differ-email-error]')
    );
  }

  var ctaSection = document.querySelector('[data-differ-cta]');
  if (ctaSection) {
    var ctaInput = ctaSection.querySelector('#DifferCtaEmail');
    bindEmailForm(
      ctaSection.querySelector('#DifferCtaForm'),
      ctaInput,
      ctaSection.querySelector('[data-differ-cta-error]')
    );

    /* Persistent join bar — appears after the first viewport, hides at the CTA */
    var joinBar = document.querySelector('[data-differ-joinbar]');
    if (joinBar) {
      var joinBtn = joinBar.querySelector('[data-differ-joinbar-btn]');
      var ctaInView = false;
      var raf = null;

      var updateBar = function () {
        var scrolled = window.scrollY > window.innerHeight * 0.7;
        joinBar.classList.toggle('is-active', scrolled && !ctaInView);
      };

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          ctaInView = entries[0].isIntersecting;
          updateBar();
        }, { threshold: 0.2 }).observe(ctaSection);
      }

      window.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; updateBar(); });
      }, { passive: true });
      updateBar();

      if (joinBtn) {
        joinBtn.addEventListener('click', function () {
          ctaSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (ctaInput) ctaInput.focus({ preventScroll: true });
        });
      }
    }
  }

  /* Header transparency on scroll */
  var header = document.querySelector('[data-header]');
  if (header && header.classList.contains('site-header--transparent')) {
    var onScroll = function () {
      if (window.scrollY > 40) {
        header.classList.add('site-header--solid');
      } else {
        header.classList.remove('site-header--solid');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Home header — hidden over the hero, slides in after scrolling past it */
  var homeHeader = document.querySelector('[data-header-home-reveal]');
  if (homeHeader) {
    var heroEl = document.querySelector('.differ-hero');
    var headerRaf = null;
    var updateHomeHeader = function () {
      var threshold = (heroEl ? heroEl.offsetHeight : window.innerHeight) * 0.85;
      homeHeader.classList.toggle('is-revealed', window.scrollY > threshold);
    };
    window.addEventListener('scroll', function () {
      if (headerRaf) return;
      headerRaf = requestAnimationFrame(function () { headerRaf = null; updateHomeHeader(); });
    }, { passive: true });
    updateHomeHeader();
  }

  /* SKU color charge on touch devices — cards light up as they scroll into view */
  var skuProducts = document.querySelectorAll('.differ-product');
  if (skuProducts.length && window.matchMedia('(hover: none)').matches && 'IntersectionObserver' in window) {
    var chargeObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-charged', entry.isIntersecting);
      });
    }, { threshold: 0.55 });
    skuProducts.forEach(function (card) { chargeObserver.observe(card); });
  }

  /* Scroll-driven SKU color wash across the products section */
  var productsSection = document.querySelector('.differ-products');
  if (productsSection) {
    var washRaf = null;
    var updateWash = function () {
      var rect = productsSection.getBoundingClientRect();
      var vh = window.innerHeight;
      var centerDist = Math.abs(rect.top + rect.height / 2 - vh / 2);
      var progress = Math.max(0, Math.min(1, 1 - centerDist / (vh / 2 + rect.height / 2)));
      productsSection.style.setProperty('--wash', progress.toFixed(3));
    };
    window.addEventListener('scroll', function () {
      if (washRaf) return;
      washRaf = requestAnimationFrame(function () { washRaf = null; updateWash(); });
    }, { passive: true });
    updateWash();
  }

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* differ-motion.js (GSAP + Lenis, homepage only) takes over magnetic and
     the spectrum sequence when it can actually run — these vanilla versions
     stand down so nothing double-animates. CDN scripts are deferred in the
     head, so window.gsap is already settled by the time this executes. */
  var gsapMotion = !!(window.gsap && window.ScrollTrigger) && !reducedMotion && document.querySelector('.differ-hero');

  /* Continuous ground — one gradient spanning the whole document, colour
     stops anchored to the measured position of each chapter. The scroll just
     travels through it: no per-section backgrounds, no seams, no black bands.
     Pure paint-once CSS; nothing runs per frame. */
  (function () {
    if (!document.querySelector('.differ-hero')) return;
    var ground = document.createElement('div');
    ground.className = 'differ-groundfield';
    ground.setAttribute('aria-hidden', 'true');
    document.body.insertBefore(ground, document.body.firstChild);
    var mid = function (sel) {
      var el = document.querySelector(sel);
      if (!el) return null;
      var r = el.getBoundingClientRect();
      return r.top + window.scrollY + r.height / 2;
    };
    var updateGround = function () {
      var docH = document.documentElement.scrollHeight;
      ground.style.height = docH + 'px';
      var hero = document.querySelector('.differ-hero');
      var heroMid = hero ? hero.offsetHeight * 0.55 : window.innerHeight * 0.55;
      var ctaEl = document.querySelector('.differ-cta');
      var ctaTop = null, ctaMid = null;
      if (ctaEl) {
        var cr = ctaEl.getBoundingClientRect();
        ctaTop = cr.top + window.scrollY;
        ctaMid = ctaTop + cr.height / 2;
      }
      /* charcoal -> slate -> forest -> bronze -> dawn -> violet-tinted charcoal */
      var stops = [['#16161A', 0], ['#16161A', heroMid]];
      var push = function (color, y) { if (y != null) stops.push([color, Math.round(y)]); };
      push('#152024', mid('.differ-statement'));
      push('#15241E', mid('.differ-manifesto'));
      push('#242115', mid('.differ-spectrum'));
      push('#151924', ctaTop);
      push('#1F1827', ctaMid);
      stops.push(['#1F1827', docH]);
      ground.style.background = 'linear-gradient(180deg, ' + stops.map(function (s) {
        return s[0] + ' ' + s[1] + 'px';
      }).join(', ') + ')';
    };
    window.__differGround = updateGround;
    window.addEventListener('resize', updateGround);
    window.addEventListener('load', updateGround);
    updateGround();
  })();

  /* Loader — shown once per session (inline head script gates it before paint).

     It used to dismiss on window.load, which waits for every subresource
     including the 48KB animation bundle. Because the loader is an opaque
     full-viewport overlay, that chain gated the first real paint and so gated
     LCP: slow script → late load → 800ms hold → 900ms fade.

     It now dismisses on DOMContentLoaded, which fires as soon as the markup is
     parsed and does not wait on deferred scripts, images or fonts. The hold is
     short enough to still read as a beat of brand rather than lag. */
  var loaderEl = document.querySelector('[data-differ-loader]');
  if (loaderEl && document.documentElement.classList.contains('differ-loading')) {
    var loaderShownAt = Date.now();
    var loaderDone = false;
    var finishLoader = function () {
      if (loaderDone) return;
      loaderDone = true;
      var hold = Math.max(0, 260 - (Date.now() - loaderShownAt));
      setTimeout(function () {
        document.documentElement.classList.add('differ-loaded');
        try { sessionStorage.setItem('differSeen', '1'); } catch (e) { /* private mode */ }
        setTimeout(function () {
          document.documentElement.classList.remove('differ-loading', 'differ-loaded');
        }, 480);
      }, hold);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', finishLoader);
    } else {
      finishLoader();
    }
    /* Failsafe only — DOMContentLoaded has already fired in practice by now */
    setTimeout(finishLoader, 1200);
  }

  /* Scene light — one warm light travels down the page with the reader,
     binding the chapters into a single continuous space */
  if (
    document.querySelector('.differ-hero') &&
    document.body.classList.contains('has-ambient') &&
    document.body.classList.contains('has-animations') &&
    !reducedMotion
  ) {
    var scene = document.createElement('div');
    scene.className = 'differ-scene';
    scene.setAttribute('aria-hidden', 'true');
    document.body.appendChild(scene);
    var sceneRaf = null;
    var updateScene = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(1, window.scrollY / max) : 0;
      /* starts below the fold, rises through the viewport as the story deepens */
      var y = window.innerHeight * (1.05 - p * 1.15) - scene.offsetHeight / 2;
      scene.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      if (!scene.classList.contains('is-live')) scene.classList.add('is-live');
    };
    window.addEventListener('scroll', function () {
      if (sceneRaf) return;
      sceneRaf = requestAnimationFrame(function () { sceneRaf = null; updateScene(); });
    }, { passive: true });
    window.addEventListener('resize', updateScene);
    updateScene();
  }

  /* Physics asterisk field — marks spring around their home points,
     repelled by the cursor (desktop) and kicked by scroll velocity (touch) */
  var fieldEl = document.querySelector('[data-differ-field]');
  if (fieldEl && !reducedMotion) {
    var fieldMarks = Array.prototype.map.call(
      fieldEl.querySelectorAll('.differ-field__mark'),
      function (el) {
        var home = (el.getAttribute('data-home') || '50,50').split(',');
        return {
          el: el,
          hx: parseFloat(home[0]) / 100,
          hy: parseFloat(home[1]) / 100,
          depth: parseFloat(el.getAttribute('data-depth')) || 1,
          x: 0, y: 0, vx: 0, vy: 0,
          rot: Math.random() * 360,
          phase: Math.random() * 6.283
        };
      }
    );
    var fieldMouseX = -9999, fieldMouseY = -9999;
    var fieldLastScroll = window.scrollY;

    window.addEventListener('mousemove', function (e) {
      fieldMouseX = e.clientX; fieldMouseY = e.clientY;
    }, { passive: true });

    window.addEventListener('scroll', function () {
      var dy = window.scrollY - fieldLastScroll;
      fieldLastScroll = window.scrollY;
      fieldMarks.forEach(function (m) {
        m.vy -= dy * 0.025 * (m.depth - 0.5);
      });
    }, { passive: true });

    var fieldRunning = false;
    var fieldTick = function (t) {
      if (document.hidden) { fieldRunning = false; return; }
      fieldRunning = true;
      if (!fieldEl.classList.contains('is-live')) fieldEl.classList.add('is-live');
      var vw = window.innerWidth, vh = window.innerHeight;
      fieldMarks.forEach(function (m) {
        /* spring home — soft, architectural drift */
        m.vx += -m.x * 0.007;
        m.vy += -m.y * 0.007;
        /* idle current so the field is never frozen */
        m.vx += Math.sin(t * 0.00025 + m.phase) * 0.007;
        m.vy += Math.cos(t * 0.0003 + m.phase) * 0.007;
        /* gentle cursor repulsion */
        var cx = m.hx * vw + m.x, cy = m.hy * vh + m.y;
        var dx = cx - fieldMouseX, dyy = cy - fieldMouseY;
        var d = Math.sqrt(dx * dx + dyy * dyy);
        if (d < 240 && d > 0.001) {
          var f = ((240 - d) / 240) * 0.5;
          m.vx += (dx / d) * f;
          m.vy += (dyy / d) * f;
        }
        m.vx *= 0.94; m.vy *= 0.94;
        m.x += m.vx; m.y += m.vy;
        m.rot += 0.018 * m.depth + m.vx * 0.12;
        m.el.style.transform =
          'translate3d(' + (m.hx * vw + m.x) + 'px,' + (m.hy * vh + m.y) + 'px,0) rotate(' + m.rot + 'deg)';
      });
      requestAnimationFrame(fieldTick);
    };
    requestAnimationFrame(fieldTick);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && !fieldRunning) requestAnimationFrame(fieldTick);
    });
  }

  /* Chapter rail — numbered spine down the right edge, built from the
     chapter markers actually on the page */
  var chapterEls = document.querySelectorAll('.differ-chapter');
  if (chapterEls.length >= 3 && 'IntersectionObserver' in window) {
    var railSections = [];
    chapterEls.forEach(function (marker) {
      var host = marker.closest('.shopify-section') || marker.parentElement;
      var num = (marker.textContent.match(/\d+/) || [''])[0];
      if (host && num) railSections.push({ host: host, num: num });
    });
    if (railSections.length >= 3) {
      var rail = document.createElement('nav');
      rail.className = 'differ-rail';
      rail.setAttribute('aria-label', 'Chapters');
      var astSvg = '<svg class="differ-ast" viewBox="0 0 100 100" aria-hidden="true"><g fill="currentColor"><polygon points="43.5,6 57,6.8 56.2,94 42.8,93.2"/><polygon points="8.5,30 15.8,18.5 91,69.5 83.8,81"/><polygon points="84.2,18.5 91.5,30 16.2,81 9,69.5"/></g></svg>';
      railSections.forEach(function (s, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'differ-rail__item';
        btn.innerHTML = astSvg + '<span>' + s.num + '</span>';
        btn.addEventListener('click', function () {
          s.host.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        rail.appendChild(btn);
        s.btn = btn;
      });
      document.body.appendChild(rail);
      requestAnimationFrame(function () { rail.classList.add('is-live'); });
      var railIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var match = railSections.find(function (s) { return s.host === entry.target; });
          if (match && entry.isIntersecting) {
            railSections.forEach(function (s) { s.btn.classList.toggle('is-active', s === match); });
          }
        });
      }, { rootMargin: '-40% 0px -40% 0px' });
      railSections.forEach(function (s) { railIO.observe(s.host); });
    }
  }

  /* Idle whisper — a line that only appears for visitors who linger */
  var whisper = document.querySelector('[data-differ-whisper]');
  if (whisper && !reducedMotion) {
    var whisperTimer = setTimeout(function () {
      if (window.scrollY < window.innerHeight * 0.3) whisper.classList.add('is-heard');
    }, 7000);
    window.addEventListener('scroll', function () {
      if (window.scrollY > window.innerHeight * 0.6) {
        clearTimeout(whisperTimer);
        whisper.classList.remove('is-heard');
      }
    }, { passive: true });
  }

  /* Energy — one accent color that travels the chapter journey with scroll:
     vermillion, hot pink, electric blue, UV violet. Feeds the scene light,
     selection, focus rings and energy asterisks. */
  (function () {
    var stops = [[201, 80, 35], [232, 40, 107], [77, 107, 255], [178, 59, 245]];
    var energyRaf = null;
    var updateEnergy = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var t = max > 0 ? Math.min(1, window.scrollY / max) : 0;
      var pos = t * (stops.length - 1);
      var seg = Math.min(stops.length - 2, Math.floor(pos));
      var f = pos - seg;
      var c1 = stops[seg], c2 = stops[seg + 1];
      var r = Math.round(c1[0] + (c2[0] - c1[0]) * f);
      var g = Math.round(c1[1] + (c2[1] - c1[1]) * f);
      var b = Math.round(c1[2] + (c2[2] - c1[2]) * f);
      document.documentElement.style.setProperty('--differ-energy', 'rgb(' + r + ',' + g + ',' + b + ')');
      document.documentElement.style.setProperty('--differ-energy-rgb', r + ',' + g + ',' + b);
    };
    window.addEventListener('scroll', function () {
      if (energyRaf) return;
      energyRaf = requestAnimationFrame(function () { energyRaf = null; updateEnergy(); });
    }, { passive: true });
    updateEnergy();
  })();

  /* Continuous lightfield — one canvas of dual-colour light spanning the
     whole document. Blobs sit over each lit chapter but are sized far
     beyond it and fade radially, so no edge can ever align with a
     section boundary. */
  var glowHosts = document.querySelectorAll('.differ-statement, .differ-manifesto, .differ-spectrum, .differ-cta, .differ-prose--glow');
  if (glowHosts.length) {
    var lightfield = document.createElement('div');
    lightfield.className = 'differ-lightfield';
    lightfield.setAttribute('aria-hidden', 'true');
    var lfBlobs = [];
    glowHosts.forEach(function (host) {
      var blob = document.createElement('div');
      blob.className = 'differ-lightfield__blob';
      /* each blob glows in its chapter's accent (set as --differ-accent-rgb in CSS) */
      var accent = getComputedStyle(host).getPropertyValue('--differ-accent-rgb').trim();
      if (accent) blob.style.setProperty('--lf-rgb', accent);
      lightfield.appendChild(blob);
      lfBlobs.push({ host: host, blob: blob });
    });
    document.body.appendChild(lightfield);
    var placeLightfield = function () {
      lightfield.style.height = document.documentElement.scrollHeight + 'px';
      lfBlobs.forEach(function (o) {
        var rect = o.host.getBoundingClientRect();
        var center = rect.top + window.scrollY + rect.height / 2;
        var size = Math.max(window.innerHeight * 1.6, rect.height * 2);
        o.blob.style.height = size + 'px';
        o.blob.style.top = (center - size / 2) + 'px';
      });
    };
    placeLightfield();
    window.addEventListener('resize', placeLightfield);
    window.addEventListener('load', placeLightfield);
  }

  /* Scroll progress thread — draws itself down the page */
  var threadFill = document.querySelector('[data-differ-thread-fill]');
  var threadTip = document.querySelector('[data-differ-thread-tip]');
  if (threadFill && threadTip) {
    var threadRaf = null;
    var updateThread = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(1, window.scrollY / max) : 0;
      threadFill.style.transform = 'scaleY(' + p.toFixed(4) + ')';
      threadTip.style.transform = 'translateY(' + (p * window.innerHeight - 7).toFixed(1) + 'px)';
    };
    window.addEventListener('scroll', function () {
      if (threadRaf) return;
      threadRaf = requestAnimationFrame(function () { threadRaf = null; updateThread(); });
    }, { passive: true });
    window.addEventListener('resize', updateThread);
    updateThread();
  }

  /* Hero exit — dissolve the hero into the next chapter while scrolling
     away (drives the .differ-hero::after veil) */
  var heroExit = document.querySelector('.differ-hero');
  if (heroExit && !reducedMotion) {
    var exitRaf = null;
    var updateExit = function () {
      var h = heroExit.offsetHeight || window.innerHeight;
      var p = Math.max(0, Math.min(1, window.scrollY / (h * 0.85)));
      heroExit.style.setProperty('--exit', p.toFixed(3));
    };
    window.addEventListener('scroll', function () {
      if (exitRaf) return;
      exitRaf = requestAnimationFrame(function () { exitRaf = null; updateExit(); });
    }, { passive: true });
    updateExit();
  }

  /* Marginalia placement is pure CSS and lives entirely in the theme editor.

     Each doodle carries three percentages — across the page, down the page, and
     width — which the section writes straight into the element as `left`, `top`
     and `--slot-w`. The browser resolves them against the field, which spans the
     whole page. There is deliberately no JavaScript here at all: every version
     that measured boxes and rewrote positions ended up moving doodles the editor
     had placed by hand, whether to dodge text, to follow a chapter, or simply
     because a font finished loading and the page got taller. Percentages need no
     measuring, so nothing can drift. */

  /* Generic scroll parallax — [data-differ-parallax] elements drift
     relative to their distance from the viewport center */
  document.querySelectorAll('.differ-atmosphere__img').forEach(function (img) {
    img.setAttribute('data-differ-parallax', '-0.08');
    img.setAttribute('data-differ-parallax-scale', '1.12');
  });
  document.querySelectorAll('.differ-product__media').forEach(function (media, i) {
    media.setAttribute('data-differ-parallax', i % 2 ? '0.06' : '-0.06');
  });
  /* Narrative blocks drift a touch slower than the page — quiet depth */
  document.querySelectorAll('.differ-statement__inner, .differ-prose__inner').forEach(function (el) {
    el.setAttribute('data-differ-parallax', '-0.045');
  });
  var parallaxEls = document.querySelectorAll('[data-differ-parallax]');
  if (parallaxEls.length && !reducedMotion) {
    var parRaf = null;
    var updateParallax = function () {
      var vh = window.innerHeight;
      parallaxEls.forEach(function (el) {
        var factor = parseFloat(el.getAttribute('data-differ-parallax')) || 0.1;
        var scale = el.getAttribute('data-differ-parallax-scale');
        var rect = el.getBoundingClientRect();
        var offset = (rect.top + rect.height / 2 - vh / 2) * factor;
        var t = el.classList.contains('differ-prose__watermark')
          ? 'translateY(calc(-50% + ' + offset.toFixed(1) + 'px))'
          : 'translateY(' + offset.toFixed(1) + 'px)' + (scale ? ' scale(' + scale + ')' : '');
        el.style.transform = t;
      });
    };
    window.addEventListener('scroll', function () {
      if (parRaf) return;
      parRaf = requestAnimationFrame(function () { parRaf = null; updateParallax(); });
    }, { passive: true });
    updateParallax();
  }

  /* Scroll-scrubbed words — text illuminates progressively with scroll */
  var scrubEls = document.querySelectorAll('[data-scrub]');
  if (scrubEls.length && !reducedMotion) {
    var scrubData = Array.prototype.map.call(scrubEls, function (el) {
      return { el: el, words: el.querySelectorAll('.differ-word') };
    });
    var scrubRaf = null;
    var updateScrub = function () {
      var vh = window.innerHeight;
      scrubData.forEach(function (s) {
        var rect = s.el.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > vh + 100) return;
        var p = (vh * 0.85 - rect.top) / (vh * 0.5);
        p = Math.max(0, Math.min(1, p));
        var lit = Math.round(p * s.words.length);
        s.words.forEach(function (w, i) { w.classList.toggle('is-lit', i < lit); });
      });
    };
    window.addEventListener('scroll', function () {
      if (scrubRaf) return;
      scrubRaf = requestAnimationFrame(function () { scrubRaf = null; updateScrub(); });
    }, { passive: true });
    updateScrub();
  }

  /* Cursor spotlight — track pointer position inside lit surfaces */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('[data-spotlight]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var rect = el.getBoundingClientRect();
        el.style.setProperty('--mx', (((e.clientX - rect.left) / rect.width) * 100).toFixed(2) + '%');
        el.style.setProperty('--my', (((e.clientY - rect.top) / rect.height) * 100).toFixed(2) + '%');
      }, { passive: true });
    });

    /* Magnetic buttons — pulled toward the cursor, spring back on leave
       (differ-motion.js runs a springier GSAP version when it can) */
    if (!reducedMotion && !gsapMotion) {
      document.querySelectorAll('[data-magnetic]').forEach(function (btn) {
        btn.addEventListener('pointerenter', function () {
          btn.style.transition = 'transform 0.45s cubic-bezier(.19,1,.22,1)';
        });
        btn.addEventListener('pointermove', function (e) {
          var rect = btn.getBoundingClientRect();
          var dx = (e.clientX - rect.left - rect.width / 2) * 0.3;
          var dy = (e.clientY - rect.top - rect.height / 2) * 0.3;
          dx = Math.max(-12, Math.min(12, dx));
          dy = Math.max(-8, Math.min(8, dy));
          btn.style.transform = 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px)';
        }, { passive: true });
        btn.addEventListener('pointerleave', function () {
          btn.style.transform = '';
        });
      });
    }
  }

  /* Scarcity counter — integers count up when they enter the viewport */
  var counterEls = document.querySelectorAll('.differ-prose__accent--upper');
  if (counterEls.length && 'IntersectionObserver' in window && !reducedMotion) {
    var counterIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        counterIO.unobserve(entry.target);
        var node = entry.target;
        var match = node.textContent.match(/\d+/);
        if (!match) return;
        var target = parseInt(match[0], 10);
        var before = node.textContent.slice(0, match.index);
        var after = node.textContent.slice(match.index + match[0].length);
        var start = null;
        var step = function (ts) {
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / 1400);
          var eased = 1 - Math.pow(1 - p, 3);
          node.textContent = before + Math.round(target * eased) + after;
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    counterEls.forEach(function (el) { counterIO.observe(el); });
  }

  /* Spectrum — marks light up in sequence when scrolled into view (touch),
     hover handles desktop via CSS */
  var spectrum = document.querySelector('[data-differ-spectrum]');
  if (spectrum && 'IntersectionObserver' in window && window.matchMedia('(hover: none)').matches && !gsapMotion) {
    var spectrumItems = spectrum.querySelectorAll('.differ-spectrum__item');
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        spectrumItems.forEach(function (item) {
          item.classList.toggle('is-lit', entry.isIntersecting);
        });
      });
    }, { threshold: 0.6 }).observe(spectrum);
  }

  /* Reading progress — journal articles */
  var readingFill = document.querySelector('[data-reading-progress]');
  if (readingFill) {
    var readRaf = null;
    var updateReading = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(1, window.scrollY / max) : 0;
      readingFill.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    };
    window.addEventListener('scroll', function () {
      if (readRaf) return;
      readRaf = requestAnimationFrame(function () { readRaf = null; updateReading(); });
    }, { passive: true });
    window.addEventListener('resize', updateReading);
    updateReading();
  }

  /* Cursor aura (desktop) — orange to electric pink across the viewport */
  if (
    window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    var aura = document.createElement('div');
    aura.className = 'differ-aura';
    aura.setAttribute('aria-hidden', 'true');
    document.body.appendChild(aura);
    var auraRaf = null;
    window.addEventListener('mousemove', function (e) {
      if (auraRaf) return;
      auraRaf = requestAnimationFrame(function () {
        auraRaf = null;
        aura.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px)';
        aura.style.setProperty('--t', (e.clientX / window.innerWidth).toFixed(3));
        aura.classList.add('is-on');
      });
    }, { passive: true });
    document.documentElement.addEventListener('mouseleave', function () {
      aura.classList.remove('is-on');
    });
  }
})();
